import styled from 'styled-components';

export const FavouritesWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const EmptyMessage = styled.div`
  color: #b3b5bd;
  font-size: 13px;
  font-weight: 400;
  font-family: 'NanumSquareRound', sans-serif;
  padding-left: 16px;
`;

export const FavouritesScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 8px;

  /* 스크롤바 완전 숨김 */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

export const ScrollButton = styled.button<{
  direction: 'left' | 'right';
  disabled?: boolean;
}>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ direction }) => (direction === 'left' ? 'left: 8px;' : 'right: 8px;')}

  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme?.COLORS?.stroke};
  background: ${({ theme }) => theme?.COLORS?.drawerBgColor || '#fff'};
  color: ${({ theme }) => theme?.COLORS?.textw};

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  z-index: 99;

  &:hover {
    ${({ disabled, theme }) =>
      !disabled &&
      `
      background: ${theme?.COLORS?.stroke};
      transform: translateY(-50%) scale(1.05);
    `}
  }

  &:active {
    ${({ disabled }) =>
      !disabled &&
      `
      transform: translateY(-50%) scale(0.95);
    `}
  }
`;
